import React from "react"
import { useSelector } from "react-redux"

import { ACTIVE, INACTIVE } from "const"
import { MtPackage } from "server/models"
import { StoreType } from "client/store"
import { TableColumnEditable } from "client/components"

import TableInput from "../components/input"
import TableSelect from "../components/select"
import { TableAllowedAccounts, TableVisibility } from "../components/visibility"

import Drive from "./drive"
import Okr from "./okr"
import Rrs from "./rrs"
import Study from "./study"
import Task from "./task"
import Project from "./project"
import Cc from "./cc"
import Lifecycle from "./lifecycle"
import Sil from "./sil"
import Qid from "./qid"
import Markov from "./markov"

export const styleOffset = { paddingLeft: "35px" }

const Columns = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    // no need to set cell width for inverted table
    const mainColumns: TableColumnEditable[] = [
        {
            field: "name",
            header: lang.name,
            focusedFormatter: (packg: MtPackage) => (
                <TableInput data={packg.name} type="text" />
            ),
        },
        {
            field: "maxUsers",
            header: lang.packageMaxUsers,
            focusedFormatter: (packg: MtPackage) => (
                <TableInput data={packg.maxUsers} type="integer" />
            ),
        },
        {
            field: "price",
            header: lang.price,
            focusedFormatter: (packg: MtPackage) => (
                <TableInput data={packg.price} type="float" />
            ),
        },
        {
            field: "status",
            header: lang.status,
            formatter: (packg: MtPackage) => lang[packg.status],
            focusedFormatter: (packg: MtPackage) => {
                const { status } = packg
                return (
                    <TableSelect
                        text={lang[status]}
                        label={lang.status}
                        property={{ status }}
                        propertyArray={[ACTIVE, INACTIVE]}
                    />
                )
            },
        },
        {
            field: "visibility",
            header: lang.visibility,
            formatter: (packg: MtPackage) => lang[packg.visibility],
            focusedFormatter: () => <TableVisibility />,
        },
        {
            field: "allowedAccounts",
            header: lang.accounts,
            formatter: (packg: MtPackage) => <TableAllowedAccounts packageId={packg.id} />,
            focusedFormatter: () => <TableVisibility />,
        },
    ]

    return mainColumns.concat(
        Drive(lang),
        Okr(lang),
        Rrs(lang),
        Study(lang),
        Task(lang),
        Project(lang),
        Cc(lang),
        Lifecycle(lang),
        Sil(lang),
        Qid(lang),
        Markov(lang),
    )
}
export default Columns
